function OptGroupSelectDropDown(props) {
  const classes = props.required ? "required" : "";

  const emptyOption = (
    <option value="" label={props.emptyOption}>
      props.emptyOption
    </option>
  );

  return (
    <div>
      {props.label && (
        <label className={classes} htmlFor={props.name}>
          {props.label}
        </label>
      )}
      <select
        className={props.className}
        defaultValue={props.defaultValue}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
      >
        {props.emptyOption && emptyOption}
        {Object.keys(props.options).map((optionGroupName) => (
          <optgroup key={optionGroupName} label={optionGroupName}>
            {props.options[optionGroupName].map(({ id, name }) => (
              <option key={name} value={id}>
                {name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {props.error && <div className="invalid-feedback">{props.error}</div>}
    </div>
  );
}

export default OptGroupSelectDropDown;
